"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorksheetContent = void 0;
/**
 * Implementation of the external WorksheetContent namespace.
 * This does not follow the Impl pattern as WorksheetContent is
 * currently just a (single) property bag.
 */
class WorksheetContent {
    constructor(_worksheet) {
        this._worksheet = _worksheet;
    }
    get worksheet() {
        return this._worksheet;
    }
}
exports.WorksheetContent = WorksheetContent;
//# sourceMappingURL=WorksheetContent.js.map